import * as React from 'react';
import { observer } from 'mobx-react';

import { useModalState } from 'shared/entities/common/hooks';
import { PopupContainer } from 'shared/components/popups';
import {
  PopupChildren,
  PopupEventType,
  PopupPosition
} from 'shared/entities/components/Popup';
import { AvatarSize } from 'shared/newEntities/components/user/Avatar';

import AvatarContainer from './AvatarContainer';
import PopupContent from './PopupContent';

import './UserPopup.modules.scss';

type Props = {
  popupPosition?: PopupPosition;
  avatarSize?: AvatarSize;
  closeOnDocumentClick?: boolean;
  children: PopupChildren;
};

const UserPopup: React.FC<Props> = ({
  popupPosition = PopupPosition.bottomRight,
  avatarSize,
  closeOnDocumentClick = true,
  children
}) => {
  const popupState = useModalState();

  return (
    <PopupContainer
      isOpen={popupState.opened}
      trigger={
        <div styleName="user-popup__avatar">
          <AvatarContainer size={avatarSize} />
        </div>
      }
      on={PopupEventType.click}
      position={popupPosition}
      closeOnDocumentClick={closeOnDocumentClick}
      closeOnEscape={false}
    >
      {(onClose, opened) => (
        <PopupContent
          content={
            React.isValidElement(children) || children === null ? (
              <>{children}</>
            ) : (
              children(onClose, opened)
            )
          }
        />
      )}
    </PopupContainer>
  );
};

export default observer(UserPopup);
